import { createAction, props } from '@ngrx/store'
import { AssignedTo, Role } from './role.state'
import { User } from '../auth/auth.state'
// type PermissionAction = 'status' | 'view' | 'add' | 'edit' | 'delete'

interface ApiPermissionPayload {
  moduleId: string
  permissionIds: string[]
}

// Action to load Department
export const loadRoles = createAction(
  '[Role] Load Roles',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful Family load
export const loadRolesSuccess = createAction(
  '[Role] Load Role Success',
  props<{
    totalCount: number
    roles: Role[]
  }>()
)

// Action for Department load failure
export const loadRolesFailure = createAction('[Role] Load Role Failure', props<{ error: string }>())

// Create Role
export const createRole = createAction(
  '[Role] Create Role',
  props<{
    name: string
    // permissions: Record<string, PermissionAction[]> // 👈 better typing
    permissions: ApiPermissionPayload[]
    isStandard: boolean
    businessIds: []
  }>()
)

export const createRoleSuccess = createAction('[Role] Create Role Success', props<{ role: Role }>())

export const createRoleFailure = createAction(
  '[Role] Create Role Failure',
  props<{ error: string }>()
)

//Update Role
export const updateRole = createAction(
  '[Role] Update Role',
  props<{
    id: string
    name: string
    // permissions: Record<string, PermissionAction[]> // 👈 better typing
    permissions: ApiPermissionPayload[]

    isStandard: boolean
    businessId: string
  }>()
)

export const updateRoleSuccess = createAction('[Role] Update Role Success', props<{ role: Role }>())

export const updateRoleFailure = createAction(
  '[Role] Update Role Failure',
  props<{ error: string }>()
)

// Action to initiate loading of role by ID
export const loadRoleById = createAction('[Role] Load Role By ID', props<{ id: string }>())

// Action when role data is loaded successfully
export const loadRoleByIdSuccess = createAction(
  '[Role] Load role By ID Success',
  props<{ role: Role }>()
)

// Action when there is an error loading the role data
export const loadRoleByIdFailure = createAction(
  '[Role] Load Role By ID Failure',
  props<{ error: string }>()
)

export const resetRoleState = createAction('[Role] Reset State')

//Load Assigned To
export const loadAssignedTo = createAction(
  '[Role] Load Assigned To',
  props<{ roleId: string; params?: string; page?: number; limit?: number }>()
)
export const loadAssignedToSuccess = createAction(
  '[Role] Load Assigned To Success',
  props<{ assignedTo: AssignedTo[]; totalCount: number }>()
)
export const loadAssignedToFailure = createAction(
  '[Role] Load Assigned To Failure',
  props<{ error: string }>()
)

//Creaete Assigned To
export const createAssignedTo = createAction(
  '[Role] Create Assigned To',
  props<{ roleId: string; userData: { userId: string }[]; businessId: string | null }>()
)

export const createAssignedToSuccess = createAction(
  '[Role] Create Assigned To Success',
  props<{ assignedTo: AssignedTo[] }>()
)

export const createAssignedToFailure = createAction(
  '[Role] Create Assigned To Failure',
  props<{ error: string }>()
)

//Upsert Valid Upto
export const upsertValidUpto = createAction(
  '[Role] Upsert Valid Upto',
  props<{ id: string; validUpto: Date | null }>()
)
export const upsertValidUptoSuccess = createAction(
  '[Role] Upsert Valid Upto Success',
  props<{ assignedTo: AssignedTo[] }>()
)
export const upsertValidUptoFailure = createAction(
  '[Role] Upsert Valid Upto Failure',
  props<{ error: string }>()
)

//Delete Assigned To
export const deleteAssignedTo = createAction('[Role] Delete Assigned To', props<{ id: string }>())
export const deleteAssignedToSuccess = createAction(
  '[Role] Delete Assigned To Success',
  props<{ assignedTo: AssignedTo[] }>()
)
export const deleteAssignedToFailure = createAction(
  '[Role] Delete Assigned To Failure',
  props<{ error: string }>()
)

//Delete Role
export const deleteRole = createAction('[Role] Delete Role', props<{ id: string }>())

export const deleteRoleSuccess = createAction('[Role] Delete Role Success', props<{ id: string }>())

export const deleteRoleFailure = createAction(
  '[Role] Delete Role Failure',
  props<{ error: string }>()
)

export const loadUnassignedUsers = createAction(
  '[Role] Load Unassigned Users',
  props<{
    roleId: string
    businessId: string | null
    businessIdtoAssign: string | null
  }>()
)

export const loadUnassignedUsersSuccess = createAction(
  '[Role] Load Unassigned Users Success',
  props<{ users: User[]; totalUserCount: number }>()
)

export const loadUnassignedUsersFailure = createAction(
  '[Role] Load Unassigned Users Failure',
  props<{ error: any }>()
)
